var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"label":_vm.$t(_vm.input.label)},on:{"change":_vm.change},model:{value:(_vm.input.val),callback:function ($$v) {_vm.$set(_vm.input, "val", $$v)},expression:"input.val"}})}
var staticRenderFns = []

export { render, staticRenderFns }